import {
    apiRequest,
    pendidikanList,
    pendidikanActive,
    pendidikanInactive
} from "../../../../../services/adapters/kepegawaian/pendidikanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pendidikanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pendidikanInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pendidikanActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository